import { Experiment } from '@ms/yammer-data/dist/state/types';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';

import { UseUIFeatureCheck } from '../types';

export const useIsMoreForYouEnabled: UseUIFeatureCheck = () =>
  useExperimentTreatmentWithoutReporting(Experiment.PageThreadHomeFeed) === 'enabled';
